import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field , reduxForm} from 'redux-form';
import {Form, Row, Col, Button} from 'react-bootstrap';
import {fields, validators, reduxFormWrapper} from '../../../../utilities/form';
import {formatDate} from '../../../../utilities/common';
import {isEmpty} from '../../../../utilities/validation';
import {saveAnswer} from '../../../../actions/jre';

class SelfMarkForm extends React.Component {

  constructor() {
      super();
      this.state = {
          attmars:[],
          partimars:[]
      }
      this.handlechange = this.handlechange.bind(this);
   }

  componentDidMount(){ // joyson
    //   console.log(this.props);
      const {users} = this.props;
    //   console.log(users);
      let answer = '';
      this.props.saveAnswer(answer,users);
      document.getElementById('submitbutton').disabled = true;
    }

    /*handlechange(e){
    e.preventDefault();
    var obj = {};
    if(e.target.name == "attendance1"){
      obj["attendance1"] = e.target.value;
       this.state.attmars.push(obj);
    }else if(e.target.name == "participation1"){
      obj["participation1"] =  e.target.value;
       this.state.partimars.push(obj);
    }
    let attmarslength = this.state.attmars.length-1;
    let partimarslength = this.state.partimars.length-1;
    if(this.state.attmars[attmarslength].attendance1 > 10 || this.state.partimars[partimarslength].participation1 > 10){
        document.getElementById('submitbutton').disabled = true;
      }else{
        document.getElementById('submitbutton').disabled = false;
      }
    this.props.handlechange(this.state.attmars,this.state.partimars);
  };*/

  handlechange(e){
    let attendance1 = "";
    let attendance2 = "";
    let participation1 = "";
    let participation2 = "";
   e.preventDefault();
   var obj = {};
//    console.log(this.props.users.length);
   if(this.props.users[1] == null){
     if(e.target.name == "attendance1"){
         obj["attendance1"] = e.target.value;
         this.state.attmars.push(obj);
     }else if(e.target.name == "participation1"){
         obj["participation1"] =  e.target.value;
         this.state.partimars.push(obj);
      }

      if(this.props.attendanceToggle == true)
      {
        attendance1 = document.getElementById("attendance1").value;
      }
      if(this.props.participationToggle == true)
      {
        participation1 = document.getElementById("participation1").value;
      }

      const re = /^[0-9\b]+$/;

      if(this.props.attendanceToggle == true &&  this.props.participationToggle == true){
        if((attendance1 != "" && participation1 != "") && (attendance1 <=10  && participation1 <= 10) && (re.test(attendance1) && re.test(participation1))){
          document.getElementById('submitbutton').disabled = false;
        }
      }else if(this.props.attendanceToggle == true && this.props.participationToggle == false){
        if(attendance1 != "" && attendance1 <=10 && re.test(attendance1)){
          document.getElementById('submitbutton').disabled = false;
        }
      }else if(this.props.attendanceToggle == false && this.props.participationToggle == true){
        if(participation1 != "" && participation1 <= 10 && re.test(participation1)){
          document.getElementById('submitbutton').disabled = false;
        }
      }

      if(e.target.value >10 || e.target.value == "" || !re.test(e.target.value))
      {
        document.getElementById('submitbutton').disabled = true;
      }

      this.props.handlechange(this.state.attmars,this.state.partimars);

  }else{

    if(e.target.name == "attendance1"){
        obj["attendance1"] = e.target.value;
        this.state.attmars.push(obj);
    }else if(e.target.name == "participation1"){
        obj["participation1"] =  e.target.value;
        this.state.partimars.push(obj);
    }else if(e.target.name == "attendance2"){
      obj["attendance2"] =  e.target.value;
       this.state.attmars.push(obj);
    }else if(e.target.name == "participation2"){
        obj["participation2"] =  e.target.value;
        this.state.partimars.push(obj);
     }

     const re = /^[0-9\b]+$/;

     if(this.props.attendanceToggle == true)
     {
       attendance1 = document.getElementById("attendance1").value;
       attendance2 = document.getElementById("attendance2").value;
    }
    if(this.props.participationToggle == true)
    {
       participation1 = document.getElementById("participation1").value;
       participation2 = document.getElementById("participation2").value;
    }

    if(this.props.attendanceToggle == true &&  this.props.participationToggle == true){
     if((attendance1 != "" && participation1 != "") && (attendance2 != "" && participation2 != "")
     && (attendance1 <=10  && participation1 <= 10) && (attendance2 <=10  && participation2 <=10 ) && (re.test(attendance1) && re.test(participation1)) && (re.test(attendance2) && re.test(participation2)))
     {
       document.getElementById('submitbutton').disabled = false;
     }else{
       document.getElementById('submitbutton').disabled = true;
     }
   }else if(this.props.attendanceToggle == true && this.props.participationToggle == false){
     if((attendance1 != "" && attendance2 != "") && (attendance1  <=10  && attendance2  <=10 ) && (re.test(attendance1) && re.test(attendance2))){
       document.getElementById('submitbutton').disabled = false;
     }else{
       document.getElementById('submitbutton').disabled = true;
     }
   }else if(this.props.participationToggle == true && this.props.attendanceToggle == false) {
     if((participation1 != "" && participation2 != "") && (participation1 <=10 && participation2 <=10) && (re.test(participation1) && re.test(participation2))){
       document.getElementById('submitbutton').disabled = false;
     }
     else{
       document.getElementById('submitbutton').disabled = true;
     }
   }

     if(e.target.value >10 || e.target.value == "" || !re.test(e.target.value))
     {
       document.getElementById('submitbutton').disabled = true;
     }
  }
    //  console.log(this.state);
     this.props.handlechange(this.state.attmars,this.state.partimars);
 };

    render() {
        const {handleSubmit, pristine, submitting, users, attendanceToggle, participationToggle,handlechange} = this.props;
        // console.log(this.props);
        let students = Object.values(users);
        // console.log(students);
        return (
            <Form onSubmit={handleSubmit} className="self-mark-form">
                <Row>
                    <Col md={12} className="form-group-student">
                        {students[0].firstName} {students[0].lastName}
                    </Col>
                </Row>
                <hr/>
                {attendanceToggle &&
                    <Row>
                        <Col md={5} className="form-group-label label-left">
                            Attendance
                        </Col>
                        <Col md={3}>
                            <Field
                                name="attendance1"
                                id="attendance1"
                                placeholder="0"
                                component={fields.Input}
                                validate={[validators.required, validators.isValidModuleScore]}
                                type="text"
                                handlechange = { this.handlechange }
                            />
                        </Col>
                        <Col md={4} className="form-group-label label-right">
                            out of 10
                        </Col>
                    </Row>
                }
                {participationToggle &&
                    <Row>
                        <Col md={5} className="form-group-label label-left">
                            Participation
                        </Col>
                        <Col md={3}>
                            <Field
                                name="participation1"
                                id="participation1"
                                placeholder="0"
                                component={fields.Input}
                                validate={[validators.required, validators.isValidModuleScore]}
                                type="text"
                                handlechange = { this.handlechange }
                            />
                        </Col>
                        <Col md={4} className="form-group-label label-right">
                            out of 10
                        </Col>
                    </Row>
                }


                {!isEmpty(students[1]) && (
                    <div>
                        <br/>
                        <hr/>
                        <Row>
                            <Col md={12} className="form-group-student">
                                {students[1].firstName} {students[1].lastName}
                            </Col>
                        </Row>
                        <hr/>
                        {attendanceToggle &&
                            <Row>
                                <Col md={5} className="form-group-label label-left">
                                        Attendance
                                </Col>
                                <Col md={3}>
                                    <Field
                                        name="attendance2"
                                        id="attendance2"
                                        placeholder="0"
                                        component={fields.Input}
                                        validate={[validators.required, validators.isValidModuleScore]}
                                        type="text"
                                        handlechange = { this.handlechange }
                                    />
                                </Col>
                                <Col md={4} className="form-group-label label-right">
                                    out of 10
                                </Col>
                            </Row>
                        }

                        {participationToggle &&
                            <Row>
                                <Col md={5} className="form-group-label label-left">
                                    Participation
                                </Col>
                                <Col md={3}>
                                    <Field
                                        name="participation2"
                                        id="participation2"
                                        placeholder="0"
                                        component={fields.Input}
                                        validate={[validators.required, validators.isValidModuleScore]}
                                        type="text"
                                        handlechange = { this.handlechange }
                                    />
                                </Col>
                                <Col md={4} className="form-group-label label-right">
                                    out of 10
                                </Col>
                            </Row>
                        }
                    </div>
                    )}
                <Row>
                    <br/>
                    <hr/>
                    <Col xs={12}>
                        <Button type="submit" bsStyle="primary" id="submitbutton">Submit</Button>
                    </Col>
                </Row>
            </Form>
        );
    }
}

/*<Button type="submit" bsStyle="primary">Submit</Button>*/
//disabled={pristine || submitting}

//joyson
const mapStateToProps = (state) => {
//   console.log(state);
//   console.log(state.answers.users.length);
    return {
        users:(state.answers.users.length>0)?state.answers.users:state.auth.users //joyson
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      saveAnswer: (answer,users) => {dispatch(saveAnswer(answer,users))}
    };
};
// end joyson
export default connect(null,mapDispatchToProps)(reduxFormWrapper(SelfMarkForm,'SelfMarkForm',''));



// WEBPACK FOOTER //
// ./src/js/components/app/jre/book/SelfMarkForm.js